module.exports = __webpack_public_path__ + "static/media/38.9efe1e03.png";